import {Component, EventEmitter, Input, Output} from '@angular/core';
import {TranslatePipe} from "@ngx-translate/core";
import {Collection, ReadonlyPermission} from "../../../collection.model";
import {MatButton} from "@angular/material/button";
import {CollectionService} from "../../../collection.service";
import {FormBuilder, FormGroup, FormsModule, ReactiveFormsModule} from "@angular/forms";
import {MatFormField, MatLabel} from "@angular/material/form-field";
import {MatOption} from "@angular/material/core";
import {MatSelect} from "@angular/material/select";

@Component({
    selector: 'app-collection-share-publication',
    imports: [
        TranslatePipe,
        MatButton,
        FormsModule,
        MatFormField,
        MatLabel,
        MatOption,
        MatSelect,
        ReactiveFormsModule
    ],
    templateUrl: './collection-share-publication.component.html',
    styleUrl: './collection-share-publication.component.scss'
})
export class CollectionSharePublicationComponent {

    @Input({required: true}) collection!: Collection;
    @Output() collectionChange = new EventEmitter<Collection>();
    @Output() back = new EventEmitter<void>();

    publicationForm: FormGroup | undefined;
    error: string | null = null;

    constructor(
        private collectionService: CollectionService,
        private fb: FormBuilder
    ) {

    }

    ngOnInit() {
        this.publicationForm = this.fb.group({
            permission: [this.collection.publication?.permission || 'download'],
        });
    }

    makePublic() {
        let permission: ReadonlyPermission = this.publicationForm?.controls['permission']?.value;
        this.collectionService.publishCollection(this.collection.uuid, permission).subscribe({
            next: (collection) => {
                this.collection = collection;
                this.collectionChange.emit(collection);
                this.back.emit();
            },
            error: (e) => {
                console.error(e);
                this.error = 'error.unknown';
            }
        });
    }
    updatePermission() {
        let permission: ReadonlyPermission = this.publicationForm?.controls['permission']?.value;
        this.collectionService.publishCollection(this.collection.uuid, permission).subscribe({
            next: (collection) => {
                this.collection = collection;
                this.collectionChange.emit(collection);
                this.back.emit();
            },
            error: (e) => {
                console.error(e);
                this.error = 'error.unknown';
            }
        });
    }

    revokePublication() {
        this.collectionService.removeCollectionPublication(this.collection.uuid).subscribe({
            next: (collection) => {
                this.collection = collection;
                this.collectionChange.emit(collection);
                this.back.emit();
            },
            error: (e) => {
                console.error(e);
                this.error = 'error.unknown';
            }
        });
    }
}
